// Cross-app session handoff exchange (ADR-0045).
//
// The PWA mints a one-time code at auth-svc and redirects the user to
// the dashboard's /auth/callback with it. This exchanges that opaque
// code for a fresh TokenPairResponse the dashboard stores as its own
// session. The endpoint design (single-use, short-TTL, live role
// re-derivation) lives in auth-svc/src/routes/handoff.ts.

import type { HandoffExchangeRequest, TokenPairResponse } from "@bitacorapro/api-types";
import { request } from "../client";

export const handoffApi = {
  // skipAuth: the dashboard has no session yet at this point — the code
  // IS the credential. A 401 here is a real "link invalid/expired".
  exchange: (code: string, signal?: AbortSignal): Promise<TokenPairResponse> =>
    request<TokenPairResponse>("POST", "auth", "/auth/handoff/exchange", {
      body: { code } satisfies HandoffExchangeRequest,
      skipAuth: true,
      ...(signal ? { signal } : {}),
    }),
};
